import { createContext } from 'react';

const initialValues = {
  /**
   * Uploads in this browser session, keyed by the caller's key (a workout id, or `product-<id>`).
   * Entries survive the transfer in a terminal state: the document reads UPLOADING both when the
   * bytes just landed and when the task died with the tab, so only this map can tell them apart.
   */
  uploads: {},
};

const initialActions = {
  startUpload: () => {},
  cancelUpload: () => {},
};

const LongSessionUploadContext = createContext(initialValues);

/** Split out because these are stable, while `uploads` changes on every accepted progress tick. */
const LongSessionUploadActionsContext = createContext(initialActions);

export default LongSessionUploadContext;
export { initialValues, initialActions, LongSessionUploadActionsContext };
